import React, { FC } from "react";
import ReactGA from "react-ga4";
import {
    FollowEntity,
    Maybe,
    PlatformPermissionFromFeatureTypes,
    User,
    useFollowMutation,
    useGetFeatureToPlatformPermissionQuery
} from "api";
import { updateCacheOnFollowUser } from "config/apollo";
import { useUpgradePlanContext } from "context/UpgradePlan/UpgradePlanContext";
import {
    CLICK_UPGRADE,
    FOLLOW_USER,
    getEventScreen
} from "utills/events";
import { Button, ButtonProps } from "@mui/material";
import { usePermissionFeatureMapping } from "hooks";
import { getUserType } from "helper";

interface UserFollowButtonProps extends Exclude<ButtonProps, "onClick"> {
    user: Maybe<User> | undefined;
    hideUnfollowButton?: boolean;
}

export const UserFollowButton: FC<UserFollowButtonProps> = ({ user, hideUnfollowButton, ...rest }) => {
    if (!user) return null;
    if (user?.isUserDeleted) return <Button hidden {...rest} disabled sx={{ visibility: "hidden" }}>Removed</Button>;
    const { platformFeatureMap } = usePermissionFeatureMapping();
    const [follow] = useFollowMutation();
    const { handleModalOpen } = useUpgradePlanContext();
    const { data } = useGetFeatureToPlatformPermissionQuery();

    const handleFollow = React.useCallback((event: React.SyntheticEvent) => {
        event.preventDefault();
        if (!data?.getFeatureToPlatformPermission?.includes(PlatformPermissionFromFeatureTypes.CanFollow)) {
            console.log('features', ':', platformFeatureMap[PlatformPermissionFromFeatureTypes.CanFollow])
            ReactGA.event(CLICK_UPGRADE, {
                event_screen: getEventScreen(),
                features: platformFeatureMap[PlatformPermissionFromFeatureTypes.CanFollow]
            });
            handleModalOpen();
            return;
        }
        ReactGA.event(FOLLOW_USER, {
            event_category: getUserType(user),
            event_screen: getEventScreen()
        });
        if (user?.isfollow === "False") {
            follow({
                variables: { data: { id: `${user?.id}`, entity: FollowEntity.User } },
                update: (cache, { data }) => {
                    updateCacheOnFollowUser(cache, user, data);
                }
            });
        }
    },
        [user?.username, user?.isfollow, data?.getFeatureToPlatformPermission, follow]
    );

    if (user?.isfollow === "False") return (
        <Button
            variant="contained"
            disableElevation
            onClick={handleFollow}
            {...rest}
        >Follow</Button>
    )
    if (user?.isfollow === "Pending" && !hideUnfollowButton) return (
        <Button
            variant="contained"
            color="secondary"
            disabled
            {...rest}
        >Pending</Button>
    )
    if (user?.isfollow === "Resolved" && !hideUnfollowButton) return (
        <Button
            variant="contained"
            color="secondary"
            disabled
            {...rest}
        >Following</Button>
    )
    return null;
}

